import React from "react";
import './VehCard.css'


const VehCard = (options) => {

    const { bgImg, id, enabled, onClick } = options;
    const className = enabled === false ? "veh-card disabled" : "veh-card";

    const handleClick = () => {
        if (enabled) {
            onClick(id);
        }
    }

    return (
        <div className={className} onClick={handleClick}>
            <img src={bgImg} alt="" />
            <span>{id}</span>
        </div>
    )
}

export default VehCard;